import { render, staticRenderFns } from "./GCEPaymentComponent.vue?vue&type=template&id=aed81b8e&scoped=true&"
import script from "./GCEPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./GCEPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed81b8e",
  null
  
)

export default component.exports